import { IDemographics } from 'types/IDemographics'
import { ActionType, getType } from 'typesafe-actions'
import * as actions from './actions'

export type DemographicsActions = ActionType<typeof actions>

export const demographicsReducer = (
  state: Partial<Readonly<IDemographics>> = {},
  action: DemographicsActions
) => {
  switch (action.type) {
    case getType(actions.updateAge):
      return {
        ...state,
        age: action.payload
      }

    case getType(actions.updateGender):
      return {
        ...state,
        gender: action.payload
      }

    case getType(actions.updateEducation):
      return {
        ...state,
        education: action.payload
      }

    case getType(actions.updatePublication):
      return {
        ...state,
        publication: action.payload
      }

    default:
      return state
  }
}
